import { DefaultError, useQuery } from '@tanstack/react-query';
import { apiClient } from 'utils';

// https://devmagellan.mmlab.cloud/api/health
export const useGetAppHealth = () => {
  return useQuery<Response, DefaultError>({
    queryKey: ['app-health'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `health`,
        withoutVersion: true,
      });

      return response;
    },
  });
};
